export const stringToBoolean = (value: string) => /true/i.test(value);
